export default __webpack_public_path__ + "static/media/secure-payment.6f87f187.svg";